export const resolutions = [
    {
        site: "Instagram",
        res:
            [
                { name: "Stories", size: "1080 x 1920" },
                { name: "Feed", size: "1080 x 1080" },
            ]

    },
    {
        site: "Facebook",
        res:
            [
                { name: "Stories", size: "1080 x 1920" },
                { name: "Wall 1", size: "1200 x 630" },
                { name: "Wall 2", size: "1200 x 1200" },
                { name: "Cover", size: "851 x 315" },
                { name: "Group", size: "640 x 334" },
            ]
    },
    {
        site: "Twitter",
        res:
            [
                { name: "Post", size: "1200 x 630" },
                { name: "Cover", size: "1500 x 500" },
                { name: "Link", size: "800 x 418" },
            ]
    },
    {
        site: "LinkedIn",
        res:
            [
                { name: "Post", size: "1200 x 1200" },
                { name: "Cover", size: "1500 x 500" },
                { name: "Link", size: "1200 x 628" },
                { name: "Stories", size: "1080 x 1920" },
            ]
    },
    {
        site: "Pinterest",
        res:
            [
                { name: "Post", size: "1200 x 630" },
                { name: "Cover", size: "1500 x 500" },
                { name: "Link", size: "1200 x 628" },
            ]
    },
    {
        site: "Youtube",
        res:
            [
                { name: "Thumbnail", size: "1280 x 720" },
                { name: "Banner", size: "2560 x 1440" },
            ]
    }
]

